import { z } from 'zod';
import { instanceMediaMetaSchema, mediaMetaSchema } from './media-types';

export const fileListItemSchema = z.object({
    id: z.string(),
    meta: mediaMetaSchema.default({}),
    displayName: z.string(),
    originalFileName: z.string(),
    contextId: z.string(),
    key: z.string(),
    eTag: z.string().optional(),
    size: z.number(),
    lastModified: z.union([ z.string().optional(), z.date().optional() ]),
});

export type MediaListItem = z.infer<typeof fileListItemSchema>;

export const instanceFileListItemSchema = z.object({
    id: z.string(),
    meta: instanceMediaMetaSchema,
    fileName: z.string(),
    contextId: z.string(),
    materialId: z.string().optional(),
    key: z.string(),
    eTag: z.string().optional(),
    size: z.number(),
    lastModified: z.union([ z.string(), z.date() ]).optional(),
});

export type InstanceMediaListItem = z.infer<typeof instanceFileListItemSchema>;
